import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorBody } from '../../../../utils/get-response-error-body';
export class SetItemsErrorV1 extends OcapiError {
    constructor(errorCode, itemAvailabilityErrors) {
        const message = `Failed to set items. API error code ${errorCode}: ${SetItemsErrorCodeV1[errorCode]}`;
        super(errorCode, message);
        this.itemAvailabilityErrors = itemAvailabilityErrors;
    }
}
export var SetItemsErrorCodeV1;
(function (SetItemsErrorCodeV1) {
    /**
     * Comments can only be set for items or deliveries that require preparation.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["CommentOnNonPrepItemOrDelivery"] = 18100] = "CommentOnNonPrepItemOrDelivery";
    /**
     * Package concessions with OnRequest schedule must have OnRequest schedule specified for all package items.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["PackageChildItemsMustHaveAllOrNoneOnRequestSchedule"] = 18101] = "PackageChildItemsMustHaveAllOrNoneOnRequestSchedule";
    /**
     * The scheduled delivery time is outside the deliverable time range for the session.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["OutsideSessionDeliverableTimeRangeForDelivery"] = 18102] = "OutsideSessionDeliverableTimeRangeForDelivery";
    /**
     * Non preparation-type deliveries cannot have items requiring preparation.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["NonPrepDeliveryWithItemRequiringPrep"] = 18103] = "NonPrepDeliveryWithItemRequiringPrep";
    /**
     * Preparation-type deliveries should contain at least one item requiring preparation.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["PrepDeliveryWithoutItemsRequiringPrep"] = 18104] = "PrepDeliveryWithoutItemsRequiringPrep";
    /**
     * Items that do not require preparation cannot be assigned to a delivery scheduled to start on-request.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["NonPrepItemScheduledOnRequest"] = 18105] = "NonPrepItemScheduledOnRequest";
    /**
     * The requested scheduling is incompatible with the delivery type.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["DeliveryTypeHasIncompatibleScheduling"] = 18106] = "DeliveryTypeHasIncompatibleScheduling";
    /**
     * Item comment exceeds maximum length.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["ItemCommentExceedsMaximumLength"] = 18107] = "ItemCommentExceedsMaximumLength";
    /**
     * Delivery comment exceeds maximum length.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["DeliveryCommentExceedsMaximumLength"] = 18108] = "DeliveryCommentExceedsMaximumLength";
    /**
     * Order comment exceeds maximum length.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["OrderCommentExceedsMaximumLength"] = 18109] = "OrderCommentExceedsMaximumLength";
    /**
     * One or more items are unavailable.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["ItemsUnavailable"] = 18111] = "ItemsUnavailable";
    /**
     * Discount(s) for one or more requested items are unavailable.
     */
    SetItemsErrorCodeV1[SetItemsErrorCodeV1["DiscountsUnavailable"] = 18112] = "DiscountsUnavailable";
})(SetItemsErrorCodeV1 || (SetItemsErrorCodeV1 = {}));
export async function getSetItemsErrorV1(error) {
    const errorBody = (await getResponseErrorBody(error));
    const errorCode = errorBody === null || errorBody === void 0 ? void 0 : errorBody.errorCode;
    if (errorCode && Object.values(SetItemsErrorCodeV1).includes(errorCode)) {
        return new SetItemsErrorV1(errorCode, errorBody === null || errorBody === void 0 ? void 0 : errorBody.itemAvailabilityErrors);
    }
    return error;
}
//# sourceMappingURL=set-items-error.js.map